import { ExclamationCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  message,
  Modal,
  Row,
  Table,
  Input,
  Select,
  List,
  Spin,
} from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import locale from "../../constants/locale.json";
import "../Common.global.css";
const { confirm } = Modal;

const flexColumnOverflow = {
  display: "flex",
  flex: "auto",
  flexDirection: "column",
  overflowY: "scroll",
};
const flexColumn = {
  display: "flex",
  flex: "auto",
  flexDirection: "column",
};

class Role extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRowKeys: [],
      selectedRows: [],
      selectedFeatureIds: [],
      roles: [],
      roleFeatureMapping: [],
      features: [],
      filteredFeatures: [],
      roleModalVisible: false,
      roleName: null,
      isNewRole: false,
      featureModalVisible: false,
    };
  }

  componentDidMount() {
    return this.refreshList();
  }

  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.setState({ selectedRowKeys, selectedRows });
  };

  refreshList = () => {
    const { accessToken } = this.props;
    this.setState({
      isLoading: true,
    });
    return fetch(`/api/v1/role/list`, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        token: accessToken,
      },
    })
      .then((res) => {
        if (!res.ok) {
          return res
            .json()
            .catch(() => {
              // Couldn't parse the JSON
              throw new Error(res.statusText);
            })
            .then(({ error }) => {
              // Got valid JSON with error response, use it
              throw new Error(error || res.statusText);
            });
        }
        return res.json();
      })
      .then(({ roles, roleFeatureMapping, features }) => {
        this.setState({
          roles,
          roleFeatureMapping,
          features,
          filteredFeatures: [],
          selectedRowKeys: [],
          selectedRows: [],
        });
      })
      .catch((err) => {
        message.error(
          err instanceof Error ? err.message : "Server cannot be reached"
        );
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  onAddClick = () => {
    this.setState({
      isNewRole: true,
      roleModalVisible: true,
      selectedFeatureIds: [],
    });
  };

  onEditClick = () => {
    const { selectedRows, roleFeatureMapping } = this.state;
    const { display_name, id } = selectedRows[0];
    this.setState({
      roleName: display_name,
      selectedFeatureIds: roleFeatureMapping
        .filter((ag) => {
          return ag.app_role_id === parseInt(id);
        })
        .map((filteredFeatures) => filteredFeatures.app_feature_id),
      isNewRole: false,
      roleModalVisible: true,
    });
  };

  onDeleteClick = () => {
    const { selectedRowKeys } = this.state;
    const { accessToken } = this.props;
    const _this = this;
    confirm({
      title: "Please confirm",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure you would like to delete the selected user?",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        return fetch(`/api/v1/role/${selectedRowKeys[0]}`, {
          method: "DELETE",
          headers: {
            "Content-type": "application/json",
            token: accessToken,
          },
        })
          .then((res) => {
            if (!res.ok) {
              return res
                .json()
                .catch(() => {
                  // Couldn't parse the JSON
                  throw new Error(res.statusText);
                })
                .then(({ error }) => {
                  // Got valid JSON with error response, use it
                  throw new Error(error || res.statusText);
                });
            }
            return res.json();
          })
          .then(() => {
            message.success("Delete Completed!");
            _this.setState({ selectedRowKeys: [] });
            _this.refreshList();
          })
          .catch((err) => {
            message.error(
              err instanceof Error ? err.message : "Server cannot be reached"
            );
          });
      },
    });
  };

  onFeatureClick = (selectedRoleId) => {
    const { roleFeatureMapping } = this.state;
    this.setState({
      filteredFeatures: roleFeatureMapping.filter((ag) => {
        return ag.app_role_id === parseInt(selectedRoleId);
      }),
      featureModalVisible: true,
    });
  };

  onFeatureModalCancel = () => {
    this.setState({
      featureModalVisible: false,
    });
  };

  onRoleModalCancel = () => {
    this.setState({
      roleModalVisible: false,
      roleName: null,
      selectedFeatureIds: [],
    });
  };

  onRoleModalOk = () => {
    const { selectedFeatureIds, roleName, isNewRole, selectedRows } =
      this.state;
    return fetch(`/api/v1/role/${isNewRole ? "new" : selectedRows[0].id}`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
        token: this.props.accessToken,
      },
      body: JSON.stringify({
        selectedFeatureIds,
        roleName,
      }),
    })
      .then((res) => {
        if (!res.ok) {
          return res
            .json()
            .catch(() => {
              // Couldn't parse the JSON
              throw new Error(res.statusText);
            })
            .then(({ error }) => {
              // Got valid JSON with error response, use it
              throw new Error(error || res.statusText);
            });
        }
        return res.json();
      })
      .then(() => {
        this.setState({
          roleModalVisible: false,
          selectedFeatureIds: [],
          roleName: null,
        });
        this.refreshList();
        return message.success(
          `Role ${isNewRole ? "Created" : "Updated"} Successfully!`
        );
      })
      .catch((err) => {
        message.error(
          err instanceof Error ? err.message : "Server cannot be reached"
        );
      });
  };

  render() {
    const {
      selectedRowKeys,
      selectedRows,
      selectedFeatureIds,
      roles,
      features,
      roleModalVisible,
      roleName,
      isLoading,
      isNewRole,
      filteredFeatures,
      featureModalVisible,
    } = this.state;
    const { currentLang } = this.props;
    const rowSelection = {
      type: "radio",
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const columns = [
      {
        title: "Name",
        dataIndex: "display_name",
        align: "center",
        sorter: (a, b) => a.display_name.localeCompare(b.display_name),
      },
      {
        title: "Feature (Count)",
        dataIndex: "feature_count",
        align: "center",
        render: (feature_count, row) => {
          if (parseInt(feature_count) === 0) {
            return <>{feature_count}</>;
          }
          return (
            <Button
              type="link"
              onClick={() => {
                this.onFeatureClick(row.key);
              }}
            >
              {feature_count}
            </Button>
          );
        },
      },
      {
        title: "Date Updated",
        dataIndex: "updated_at",
        ellipsis: true,
        align: "center",
        render: (updated_at) => {
          return <>{moment(updated_at).format("DD/MM/YYYY HH:mm")}</>;
        },
        sorter: (a, b) =>
          moment(a.updated_at).unix() - moment(b.updated_at).unix(),
      },
      {
        title: "Date Created",
        dataIndex: "inserted_at",
        ellipsis: true,
        align: "center",
        render: (inserted_at) => {
          return <>{moment(inserted_at).format("DD/MM/YYYY HH:mm")}</>;
        },
        sorter: (a, b) =>
          moment(a.inserted_at).unix() - moment(b.inserted_at).unix(),
      },
    ];

    return (
      <div className="site-feature-container">
        <div className="page-header-container">
          <div>
            <div className="page-header-main">
              {locale.app.feature.system.title[currentLang]}
            </div>
            <div className="page-header-sub">
              {locale.app.feature.role.title[currentLang]}
            </div>
          </div>
        </div>
        <Card bodyStyle={flexColumn} style={flexColumnOverflow}>
          <Spin tip="Please Wait..." spinning={isLoading}>
            <Row>
              <div className="setting-section-search">
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Col
                    className="setting-detail-group"
                    style={{ padding: "0px" }}
                  >
                    <Button
                      key="Add"
                      className="setting-section-search-btn"
                      type="primary"
                      onClick={this.onAddClick}
                    >
                      Add
                    </Button>
                    <Button
                      key="Edit"
                      className="setting-section-search-btn"
                      onClick={this.onEditClick}
                      disabled={
                        selectedRows.length === 0 ||
                        selectedRows[0].is_super_role
                      }
                    >
                      Edit
                    </Button>
                    <Button
                      key="Delete"
                      className="setting-section-search-btn"
                      danger
                      onClick={this.onDeleteClick}
                      disabled={
                        selectedRows.length === 0 ||
                        selectedRows[0].is_super_role
                      }
                    >
                      Delete
                    </Button>
                  </Col>
                </Row>
              </div>
            </Row>
            <Row>
              <div className="table-section-header">Roles</div>
              <Table
                rowKey="id"
                style={{ overflow: "auto", width: "100%" }}
                rowSelection={rowSelection}
                columns={columns}
                dataSource={roles}
                size="small"
                scroll={{ x: "max-content" }}
              />
            </Row>
          </Spin>
        </Card>
        <Modal
          title={"Roles"}
          closable={false}
          visible={roleModalVisible}
          onOk={this.onRoleModalOk}
          onCancel={this.onRoleModalCancel}
          okButtonProps={{
            disabled: !roleName || !selectedFeatureIds.length || isLoading,
          }}
          cancelButtonProps={{ disabled: isLoading }}
        >
          <Row>
            <Col span={24} className="visitor-detail-group">
              <Input.Group
                compact
                className="group-compact-select-wrapper"
                style={{ marginBottom: "10px" }}
              >
                <span className="ant-input-group-addon group-addon-label">
                  Name <span style={{ color: "red" }}>*</span>
                </span>
                <Input
                  value={roleName}
                  disabled={!isNewRole}
                  onChange={(evt) => {
                    this.setState({
                      roleName: evt.target.value,
                    });
                  }}
                />
              </Input.Group>
              <Input.Group
                compact
                className="group-compact-select-wrapper"
                style={{ marginBottom: "10px" }}
              >
                <span className="ant-input-group-addon group-addon-label">
                  Features <span style={{ color: "red" }}>*</span>
                </span>
                <Select
                  mode="multiple"
                  maxTagCount={1}
                  className="group-addon-input"
                  value={selectedFeatureIds}
                  onChange={(val) => this.setState({ selectedFeatureIds: val })}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {features.map((ft) => (
                    <Select.Option value={ft.id} key={ft.id}>
                      {ft.display_name}
                    </Select.Option>
                  ))}
                </Select>
              </Input.Group>
            </Col>
          </Row>
        </Modal>
        <Modal
          title={`Features`}
          onCancel={this.onFeatureModalCancel}
          visible={featureModalVisible}
          footer={null}
          cancelButtonProps={{ disabled: isLoading }}
        >
          <List
            dataSource={filteredFeatures}
            renderItem={(item) => (
              <List.Item key={item.key}>
                <div>{item.display_name}</div>
              </List.Item>
            )}
          ></List>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps({ auth }) {
  return {
    accessToken: auth.token.accessToken,
  };
}

export default connect(mapStateToProps, null)(Role);
